import { useAppStore, useTVStore } from '@/shared/store'
import { defaultProfile } from '@/shared/constants'
import { getFavorites } from '@/features/favorites/FavoritesRepository'

const useFavoritesChannels = () => {
    const { actualProfile } = useAppStore()
    const { setFavoriteChannels } = useTVStore()

    const getFavoritesChannels = async () => {
        if (actualProfile) {
            const { id } = actualProfile
            if (id === defaultProfile.id) return
            const favoriteChannels = await getFavorites(id)
            const uniqueSet: Set<string> = new Set()

            favoriteChannels?.forEach((item: number | string) => {
                uniqueSet.add(String(item))
            })

            const uniqueArray = [...uniqueSet]
            setFavoriteChannels(uniqueArray)
        }
    }

    return { getFavoritesChannels }
}

export default useFavoritesChannels
